import Swiper from "swiper/swiper-bundle.esm";
function handleSwiper(swiper) {
  var TYPE_CONTROL =
    swiper.slides[swiper.activeIndex].classList.contains("has-video");
  var autoplayDelay = swiper.params.autoplay.delay / 1000;
  var VIDEO = swiper.slides[swiper.activeIndex].firstElementChild;

  // console.log("swiper.slides[swiper.activeIndex]", swiper.slides[
  //   swiper.activeIndex
  // ].firstElementChild)


  /* get Current Time */
  // function getCurrentTime() {
  if (TYPE_CONTROL) {



    getCurrentTime = function () {
      var endTime = VIDEO.duration.toFixed();
      var currentTime = VIDEO.currentTime.toFixed();
      // console.log("endTime:", endTime)
      // console.log("currentTime:", currentTime)

      if (currentTime == endTime - autoplayDelay) {
        swiper.autoplay.start();
      }
    }
  }
  /* end get Current Time */
  /* ------- TYPE_CONTROL -------- */
  if (TYPE_CONTROL) {
    /* AUTO_PLAY OFF */
    swiper.autoplay.stop();
    // console.log("TYPE_CONTROL:", TYPE_CONTROL);

    swiper.slides[
      swiper.activeIndex
    ].firstElementChild.nextElementSibling.nextElementSibling.style.display =
      "flex";

    swiper.slides[
      swiper.activeIndex
    ].firstElementChild.nextElementSibling.classList.add("pause-icon");
    swiper.slides[
      swiper.activeIndex
    ].firstElementChild.nextElementSibling.classList.remove("play-icon");

    swiper.slides[
      swiper.activeIndex
    ].firstElementChild.nextElementSibling.addEventListener(
      "click",
      PlayVideo,
      false
    );
    /* PlayVideo */
    function PlayVideo(e) {
      e.preventDefault();
      e.stopPropagation();

      if (swiper.slides[swiper.activeIndex].firstElementChild.paused) {
        this.classList.add("play-icon");
        this.classList.remove("pause-icon");
        /*
        swiper.slides[
          swiper.activeIndex
        ].firstElementChild.nextElementSibling.nextElementSibling.style.display =
          "none";
          */
      } else {
        this.classList.add("pause-icon");
        this.classList.remove("play-icon");
        /*
        swiper.slides[
          swiper.activeIndex
        ].firstElementChild.nextElementSibling.nextElementSibling.style.display =
          "flex";
          */
      }
    }
    /* end PlayVideo */
    /* VIDEO MUTED ON OFF */
    let mutedBTN =
      swiper.slides[swiper.activeIndex].firstElementChild
        .nextElementSibling.nextElementSibling;

    mutedBTN.addEventListener("click", mutedOnOff, false);
    /* mutedOnOff */
    function mutedOnOff(e) {
      e.preventDefault();
      e.stopPropagation();

      mutedBTN.classList.remove("mute-btn--toggled");

      if (swiper.slides[swiper.activeIndex].firstElementChild.muted) {
        mutedBTN.classList.add("mute-btn--toggled");
      } else {
        mutedBTN.classList.remove("mute-btn--toggled");
      }
    }
    /* end mutedOnOff */
    /* --------------- */
    if (swiper.slides[swiper.activeIndex].firstElementChild.muted) {
      mutedBTN.classList.add("mute-btn--toggled");
    } else {
      mutedBTN.classList.remove("mute-btn--toggled");
    }
    /* --------------- */

    VIDEO.ontimeupdate = function () {
      getCurrentTime();
    };


    /* --------------- */
    for (var i = 0; i < swiper.slides.length; i++) {
      var video = swiper.slides[i].querySelector("video");
      var activeVideo = swiper.slides[swiper.activeIndex].querySelector("video");
      if (swiper.slides[i].classList.contains("has-video")) {
        video.muted = true;
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.then(_ => {
            console.log("Automatic playback started! ")
          })
            .catch(error => {
              console.log("error -> ", error)
            });
        }
        console.log("...")
      }
    }
  } else {
    /* AUTO_PLAY ON */
    swiper.autoplay.start();

    for (var i = 0; i < swiper.slides.length; i++) {
      var video = swiper.slides[i].querySelector("video");
      var TYPE_CONTROL =
        swiper.slides[swiper.activeIndex].classList.contains("has-video");
      if (swiper.slides[i].classList.contains("has-video")) {
        // video.pause();
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.then(_ => {
            if (TYPE_CONTROL) {
              console.log("We can now safely pause video...")
              video.pause();
            }
          })
            .catch(error => {
              console.log("error -> ", error)
            });
        }
        video.muted = true;
      }
    }
  }
  /* ------- TYPE_CONTROL -------- */
}

export function getPromoSwiper() {
  // console.log("getPromoSwiper");
  const swiper = new Swiper("#promoSwiper", {
    loop: false,
    // cssMode: true,
    // effect: 'fade',
    speed: 500,
    init: true,
    slidesPerView: 1,
    // effect: "slide",
    effect: "creative",
    creativeEffect: {
      prev: {
        shadow: false,
        translate: ["-20%", 0, -1],
      },
      next: {
        translate: ["100%", 0, 0],
      },
    },
    // parallax: true,

    watchSlidesProgress: true,
    direction: "horizontal",
    autoplay: {
      delay: 6000,
    },
    keyboard: true,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      loadPrevNext: true,
    },
    on: {
      afterInit: function (swiper) {
        // console.log("getPromoSwiper - afterInit", swiper.activeIndex);
        handleSwiper(swiper);
      },
      slideChange: function (swiper) {
        // console.log("getPromoSwiper - slideChange", swiper.activeIndex);
        handleSwiper(swiper);
        // console.log("slidechange:");
        // var TYPE_CONTROL =
        //   swiper.slides[swiper.activeIndex].classList.contains("has-video");
        // // console.log("TYPE_CONTROL: ", TYPE_CONTROL)
        // if (TYPE_CONTROL) {
        //   // getCurrentTime();
        // }

      },
    },
  });
}

/* aboutSwiper */
function aboutSwiper() {
  const aboutSwiper = document.getElementById("aboutSwiper");
  if (aboutSwiper) {
    var swiper = new Swiper("#aboutSwiper", {
      effect: "fade",
      // parallax: true,
      allowTouchMove: true,
      loop: true,
      speed: 900,
      init: true,
      preloadImages: true,
      hashNavigation: {
        watchState: true,
      },
    });
  }
}
export { aboutSwiper };
/* aboutSwiper */
/* */
function brandSwiper() {

  const brandSwiper = document.getElementById("brandSwiper");
  if (brandSwiper) {
    var swiper = new Swiper("#brandSwiper", {
      navigation: {
       nextEl: ".swiper-button-next",
       prevEl: ".swiper-button-prev"
      },
      simulateTouch: false,
      effect: "fade",
      // parallax: false,
      // allowTouchMove: true,
      // direction: "horizontal",
      loop: false,
      speed: 600,
      init: true,
      // preloadImages: true,
      // hashNavigation: {
      //  watchState: true,
      // },
      // breakpoints: {
      //   768: {
      //     direction: "vertical",
      //   },
      // },
    });



    const brandFirstScreen = document.getElementById("brandFirstScreen");
    const brandSecondScreen = document.getElementById("brandSecondScreen");
    const menuItems = document.querySelectorAll('.menu-item');
    
    // Initialize state variables
    let isHovering = false;
    let isTransitioning = false;
    let currentlySelected = menuItems[0];
    
    // Initialize Swiper
    const swiper = new Swiper('#brandSwiper', {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        speed: 0,
        allowTouchMove: false,
        autoplay: false,
        loop: false,
        simulateTouch: false,
        on: {
            init: function() {
                // Initialize gallery swipers for each slide
                document.querySelectorAll('.brand-gallery-swiper').forEach((galleryEl, index) => {
                    new Swiper(galleryEl, {
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true
                        },
                        speed: 400,
                        autoplay: {
                            delay: 2000,
                            disableOnInteraction: false
                        },
                        pagination: {
                            el: galleryEl.querySelector('.swiper-pagination'),
                            clickable: true,
                            type: 'bullets'
                        }
                    });
                });
            }
        }
    });

    // Set initial state
    brandSecondScreen.classList.add('hideTheSlider');
    currentlySelected?.classList.add('selected');

    // Handle URL hash on page load
    const currentHash = window.location.hash;
    if (currentHash) {
        const slideIndex = parseInt(currentHash.replace('#brand-', ''));
        if (!isNaN(slideIndex)) {
            showSecondScreen();
            swiper.slideTo(slideIndex);
            updateMenuSelection(slideIndex);
        }
    } else {
        setTimeout(() => {
            history.replaceState(null, null, window.location.pathname);
        }, 40);
    }

    function showSecondScreen() {
        window.scrollTo(0, 0);
        brandFirstScreen.classList.add('clickHide');
        brandSecondScreen.classList.remove('hideTheSlider');
        brandSecondScreen.classList.add('showAnimTheSlider');
    }

    function updateMenuSelection(index) {
        if (currentlySelected) {
            currentlySelected.classList.remove('selected');
        }
        const newSelected = menuItems[index];
        if (newSelected) {
            newSelected.classList.add('selected');
            currentlySelected = newSelected;
        }
    }

    function handleImageTransition(targetId) {
        const targetImage = document.getElementById(targetId);
        const currentImage = document.querySelector('.image.active');

        if (currentImage === targetImage || !targetImage) return;

        if (currentImage) {
            currentImage.classList.remove('active');
            currentImage.classList.add('hidden');
            setTimeout(() => {
                currentImage.style.transform = 'translateX(100%)';
            }, 50);
        }

        targetImage.classList.remove('hidden');
        targetImage.style.transform = 'translateX(-100%)';

        setTimeout(() => {
            targetImage.classList.add('active');
            targetImage.style.transform = 'translateX(0)';
        }, 10);
    }

    menuItems.forEach(menuItem => {
        // Click handler
        menuItem.addEventListener('click', function(event) {
            const slideIndex = parseInt(this.getAttribute('data-slide'));
            if (isNaN(slideIndex)) return;

            showSecondScreen();
            updateMenuSelection(slideIndex);
            
            // Use a small delay to ensure smooth transition
            setTimeout(() => {
                swiper.slideTo(slideIndex);
            }, 50);
        });

        // Hover handler
        menuItem.addEventListener('mouseenter', function() {
            if (isTransitioning || isHovering) return;

            const slideIndex = parseInt(this.getAttribute('data-slide'));
            if (isNaN(slideIndex)) return;

            isHovering = true;
            isTransitioning = true;

            updateMenuSelection(slideIndex);
            handleImageTransition(this.getAttribute('data-target'));

            setTimeout(() => {
                swiper.slideTo(slideIndex);
                isHovering = false;
                isTransitioning = false;
            }, 20);
        });

        // Mouse leave handler
        menuItem.addEventListener('mouseleave', function(event) {
            if (currentlySelected === event.target) return;
            event.target.classList.remove('selected');
        });
    });

  }
}
export { brandSwiper };